import * as React from 'react';
import { Button, Col, Form, FormGroup, Label, Modal, Row } from 'reactstrap';
import { Svg } from '../Svg';

interface IResetPasswordModalProps {
  isOpen: boolean;
  handleSave: () => void;
  toggleValidationModal: () => void;
}

export const PropositionDeletionModal: React.SFC<IResetPasswordModalProps> = ({
  handleSave,
  isOpen,
  toggleValidationModal,
}) => {
  return (
    <Modal className='position-relative' isOpen={isOpen}>
      <Svg
        className='position-absolute'
        fill='primary'
        width={280}
        height={210}
        opacity={0.1}
        src='bulle-popin'
        style={{ top: '-19px', left: '-15px' }}
      />
      <div className='d-flex justify-content-end p-3'>
        <Svg
          fill='dark'
          src='close'
          width={16}
          onClick={toggleValidationModal}
        />
      </div>
      <Form className='p-5' style={{ zIndex: 1 }}>
        <FormGroup>
          <Label>Voulez-vous vraiment refuser ce projet ?</Label>
        </FormGroup>
        <Row className='d-flex justify-content-end'>
          <Col xs='6'>
            <Button
              className='text-uppercase text-white bg-dark border-0 mt-3'
              onClick={toggleValidationModal}
            >
              Retour
            </Button>
          </Col>
          <Col xs='6'>
            <Button
              className='text-uppercase text-white bg-primary float-right border-0 mt-3'
              onClick={handleSave}
            >
              Valider
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/shared/Modals/PropositionDeletionModal.tsx